// The UI that answers C3 step 4 ("N changes are not saved yet and will be
// removed") for transitions no screen asked about itself (an account
// switch). Registered by the app shell's TransitionConfirmHost.
import type { C3Reason } from './offline.codes'

export type TransitionConfirmer = (count: number, reason: C3Reason) => Promise<boolean>

let confirmer: TransitionConfirmer | null = null

export function registerTransitionConfirmer(fn: TransitionConfirmer | null): () => void {
  confirmer = fn
  return () => { if (confirmer === fn) confirmer = null }
}

export function currentTransitionConfirmer(): TransitionConfirmer | null {
  return confirmer
}
